import { render, staticRenderFns } from "./edit-style-component.vue?vue&type=template&id=9a7b40ea&"
import script from "./edit-style-component.vue?vue&type=script&lang=js&"
export * from "./edit-style-component.vue?vue&type=script&lang=js&"
import style0 from "./edit-style-component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
